<template>
    <div class="infoEvent">
        <div class="flower">
            <img style="width: 5rem;"
                src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Fdetalles-evento.svg?alt=media&token=347530ad-9075-47c3-a741-f00d8df36892"
                alt="">
        </div>
        <div class="title">
            <h2>Detalles del evento</h2>
        </div>
        <div class="branch">
            <img style="width: 10rem;"
                src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Fhojitas.svg?alt=media&token=883c9ab9-ff87-4fb9-83e6-07d1b7830e43"
                alt="">
        </div>
        <div class="event">
            <div id="ceremonia">
                <h2>Lugar:</h2>
            </div>
            <p style="font-size: 1.3rem; color:#1b2a65; text-transform: uppercase;"> {{ InfoEvent.LugarEvento }}</p>
            <p style="color:#1b2a65;">Carretera a Panchimalco km 12.8, RN 6S</p>
            <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Frecepcion.png?alt=media&token=d538bc13-9e86-41e4-b5e5-22fb1e2d9862"
                style="height: 15rem; width: 15rem;" alt="">
                <span style="font-family: 'Gwendolyn' !important; font-size: 1.5rem; color:#1b2a65; font-size: 1.8rem;">Hora:</span>
            <p style="color:#1b2a65;"> apartir de las</p>
            <h2 class="hour">{{ moment(InfoEvent.FechaHoraEvento, "LT") }}</h2>
            <div class="buttons">
                <button @click="goToGps(InfoEvent.LinkMap);"><font-awesome-icon
                        :icon="['fas', 'map-location-dot']" /> Cómo Llegar</button>
                <button @click=" goToGps(InfoEvent.LinkWaze);"><font-awesome-icon
                        :icon="['fab', 'waze']" /> Cómo Llegar</button>
                <add-to-calendar-button name="Navidad Skycom" startDate="2023-12-15" startTime="18:00"
                    endTime="23:00" timeZone="America/El_Salvador" customCss="<%= BASE_URL %>/css/btnSkyCom.css"
                    buttonStyle="custom" location="Albaclara"
                    options="'Apple','Google'" label="Recordar Evento" inline listStyle="modal"
                    customLabels='{"close":"Cerrar"}' lightMode="bodyScheme" hideBackground>
                </add-to-calendar-button>
            </div>
        </div>
        <div class="dresscode">
            <h2>Dress Code</h2>
            <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Fdress-code.svg?alt=media&token=d1cfd7b7-9f67-4951-bca3-3c5cd4a392d3"
                style="width: 12rem;" alt="">
            <p style="text-align: center; color: #1b2a65;">Código de vestimenta: De etiqueta</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from "moment";
import AddToCalendarButton from 'add-to-calendar-button';


export default {
    name: 'InfoEvento',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    components: {
        AddToCalendarButton,
    },
    data() {
        return {
            InfoEvent: {},
        };
    },
    methods: {
        GetInfoEvent() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}Event/GetInfoEvent/${this.Code}` : `${process.env.VUE_APP_API_PRO}Event/GetInfoEvent/${this.Code}`;
            axios.get(url)
                .then((response) => this.InfoEvent = response.data)
                .catch(err => console.error(err));
        },

        moment: function (date, format) {
            var _date = new Date(date.replaceAll("T", " ").replaceAll(".000Z", ""))
            return moment(_date).locale("es-mx").format(`${format}`);
        },

        goToGps(link) {
            window.open(link, '_blank');
        },
    },
    created() {
        this.GetInfoEvent();
    },
}
</script>

<style scoped>
.infoEvent {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 15px;
    width: 100%;
    justify-items: center;
    color: #6b8181;
}

.flower {
    grid-area: 1 / 1 / 2 / 4;
}

.title {
    grid-area: 2 / 1 / 3 / 4;
}

.branch {
    grid-area: 3 / 1 / 4 / 4;
}

.branch>img {
    width: 100%;
}

.subtitle {
    grid-area: 4 / 1 / 5 / 4;
}

button {
    background-color: #0076e6;
    border-radius: 0.5rem;
    height: 2.6rem;
    width: 10.8rem;
    justify-self: center;
    border-radius: 6px;
    margin-top: 0.45rem;

}

.event {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    align-items: baseline;
    justify-items: center;
    width: 100%;
}

.reception {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    place-items: center;
    width: 100%;
}

.dresscode {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    place-items: center;
    width: 100%;
}

.buttons {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 10px;
    grid-row-gap: 0px;
    height: 100%;
    padding-bottom: 1rem;
}

h2 {
    font-family: 'Gwendolyn';
    font-size: 2em;
    color: #1b2a65;
    font-weight: 100;
}

.hour {
    color: #1b2a65;
    font-family: 'roboto';
}

@media (max-width: 768px) {
    .infoEvent {
        grid-template-columns: 1fr;
        grid-row-gap: 15px;
    }

    .flower {
        grid-area: 1 / 1 / 2 / 2;
    }

    .title {
        grid-area: 2 / 1 / 3 / 2;
    }

    .branch {
        grid-area: 3 / 1 / 4 / 2;
    }

    .branch>img {
        width: 100%;
    }

    .subtitle {
        grid-area: 4 / 1 / 5 / 2;
    }

    .event {
        grid-area: 5 / 1 / 6 / 2;
        grid-row-gap: 10px;
        padding-bottom: 1rem;
    }

    .reception {
        grid-area: 6 / 1 / 7 / 2;
        grid-row-gap: 10px;
    }

    .buttons {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: repeat(2, 1fr);
        grid-column-gap: 0px;
        grid-row-gap: 10px;
        height: 100%;
    }

    #ceremonia {
        height: 2rem !important;
    }
}</style>